import React from 'react'
// libs
import { useLazyQuery } from '@apollo/client/react'
// components
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE } from 'components/UI'
// graphql
import { GET_MSAL_URL_QUERY } from 'graphql/active-directory/queries'

type QueryResponse = { activeDirectoryGetAdminAuthUrl: string }

const ConnectActiveDirectory: React.FC = () => {
  const [getUrl, { loading }] = useLazyQuery<QueryResponse>(GET_MSAL_URL_QUERY)

  const onClick = async () => {
    const { data } = await getUrl()

    const authUrl = data?.activeDirectoryGetAdminAuthUrl

    if (authUrl) {
      window.location.href = authUrl
    }
  }

  return (
    <Button style={CREATE_BUTTON_STYLE} layout={BUTTON_LAYOUTS.PURPLE} onClick={onClick} isLoading={loading}>
      Connect Active Directory
    </Button>
  )
}

export default ConnectActiveDirectory
